<template>
  <sweet-modal
    ref="modal"
    icon="warning"
    @close="resetShowUseModal"
    hide-close-button
  >
    <p>{{ $t('modals.use_template') }}</p>
    <template #button>
      <button class="btn btn-default right-margin" @click="close">
        {{ $t('modals.close_button') }}
      </button>
      <button class="btn btn-primary" @click="useAndClose">
        {{ $t('modals.confirm_use') }}
      </button>
    </template>
  </sweet-modal>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';

export default {
  name: 'UseTemplateModal',
  components: {
    SweetModal
  },
  computed: mapState({
    showUseModal: state => state.showUseModal
  }),
  methods: {
    resetShowUseModal: function () {
      this.setShowUseModal(false);
    },
    close: function () {
      this.$refs.modal.close();
    },
    useAndClose: function () {
      this.$refs.modal.close();
      this.useTemplate();
    },
    ...mapActions(['useTemplate']),
    ...mapMutations(['setShowUseModal'])
  },
  watch: {
    showUseModal: function (newValue) {
      if (newValue === true) {
        this.$refs.modal.open();
      }
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}
</style>
